
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { clearStaleAuthData } from '@/utils/auth-cleanup';
import { getLogger } from '@/utils/logger';

const log = getLogger({ module: 'LogoutPage' });

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  useEffect(() => {
    const performLogout = async () => {
      try {
        log.info('Performing logout');
        
        // Clear any stale auth data after explicit logout
        clearStaleAuthData();
        
        // Perform the logout in our Auth context (this handles signOut internally)
        await logout();
        
        setIsLoggingOut(false);
        toast({
          title: "Logged out successfully",
          description: "You have been logged out of your account.",
        });
        
        // Navigate to home page
        navigate('/home', { replace: true });
      } catch (error) {
        console.error('Logout error:', error);
        toast({
          title: "Logout Error",
          description: "There was an error logging out. Please try again.",
          variant: "destructive",
        });
        setIsLoggingOut(false);
      }
    };

    if (isLoggingOut) {
      performLogout();
    }
  }, [logout, navigate, toast, isLoggingOut]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-primary"></div>
    </div>
  );
};

export default Logout;
